export default __webpack_public_path__ + "static/media/pf_logo_oficial.9d1d8876.jpg";